// Main nav menuItems
export const routes = {
  DASHBOARD: '/',
  OWNERS: '/owners',
  PENSIONERS: '/pensioners',
  SUPERVISIONS: '/supervisions',
  RESERVATIONS: '/reservations',
  SUPERVISION_PRICES: '/supervision-prices',
  INVOICES: '/invoices',
  MAIL_SENDER: '/mail-sender',
  USERS: '/users',
  TEMPLATE_DOCS: '/template-docs',
  TEMPLATE_MAILS: '/template-mails',
  WORKFLOWS: '/workflows',
  MAILS: '/mails'
};

// Main nav subMenuItems
export const subRoutes = {
  INVOICES: {
    CUSTOMERS: '/customers',
    INTERN: '/intern'
  }
};

// Main nav groups (titles of the sections, keys of `routes`)
export const navGroups = [
  { key: 'pilotage', routes: ['DASHBOARD'] },
  {
    key: 'activity',
    routes: ['OWNERS', 'PENSIONERS', 'SUPERVISIONS', 'RESERVATIONS']
  },
  { key: 'billing', routes: ['SUPERVISION_PRICES', 'INVOICES'] },
  { key: 'communication', routes: ['MAIL_SENDER', 'TEMPLATE_MAILS', 'MAILS'] },
  { key: 'administration', routes: ['USERS', 'TEMPLATE_DOCS', 'WORKFLOWS'] }
];

// Other routes
export const outOfNavRoutes = {
  LOGIN: '/login',
  CONFIRMATION: '/email-confirmation',
  MAINTENANCE: '/maintenance',
  PROFILE: '/profile',
  SETTINGS: '/settings'
};

// url search parameters
export const pathSearches = {};
